import { p as s } from "./DefaultPropsProvider-CFfEbxdP.mjs";
const l = {
  theme: void 0
};
function u(o) {
  let m, n;
  return function(t) {
    let e = m;
    return (e === void 0 || t.theme !== n) && (l.theme = t.theme, e = s(o(l)), m = e, n = t.theme), e;
  };
}
const r = u;
export {
  r as m
};
//# sourceMappingURL=memoTheme-BzXKG_-k.mjs.map
